import { z } from 'zod';
import { UpsertRecyclingProductRequestBody } from '@/src/apis/rest/recyclingProducts.dtos';

export const DEFAULT_VALUES: UpsertRecyclingProductRequestBody = {
  category: '',
  isExposed: true,
  isEventProduct: false,
  productMediaId: 0,
  recyclingProductOptions: [],
  removeIds: [],
};

export const formSchema = () => {
  return z.object({
    category: z.string().min(1, '품목 명을 입력해주세요'),
    productMediaId: z.number().min(1, '품목 이미지를 입력해주세요'),
    isExposed: z.boolean(),
    isEventProduct: z.boolean(),
    recyclingProductOptions: z.any(),
  });
};

export const formFields = {
  category: {
    name: 'category',
  },
  isExposed: {
    name: 'isExposed',
  },
  isEventProduct: {
    name: 'isEventProduct',
  },
  productMediaId: {
    name: 'productMediaId',
  },
  recyclingProductOptions: {
    size: {
      name: 'size',
    },
    weight: {
      name: 'weight',
    },
    carbonEmissionReduction: {
      name: 'carbonEmissionReduction',
    },
    pineScore: {
      name: 'pineScore',
    },
  },
} as const;
